export const contentConstants = {
  
  ANNOUNCEMENT_SUBMIT_START: "ANNOUNCEMENT_SUBMIT_START",
  ANNOUNCEMENT_SUBMIT_SUCCESS: "ANNOUNCEMENT_SUBMIT_SUCCESS",
  ANNOUNCEMENT_SUBMIT_FAILURE: "ANNOUNCEMENT_SUBMIT_FAILURE",
  UPDATE_SELECTED_ALERT_PAGE : "UPDATE_SELECTED_ALERT_PAGE",
};
